import { isActivityConfirmed } from './EnrollmentHelper'
import { generateQRCodesForEnrollment } from './QRHelper'
import type { Enrollment } from '../types/GrooverTypes'

/** First check-in QR (`v/…` or `s/…`) for an enrollment, or null if none can be generated. */
export const getPrimaryCheckinQrForEnrollment = (
  enrollment: Pick<Enrollment, 'id' | 'activities' | 'activityQuantities' | 'statuses'>
): string | null => {
  if (!enrollment.id || !enrollment.activities?.length) return null

  const approved = enrollment.activities.filter((activity) => isActivityConfirmed(enrollment, activity.id))
  const activities = approved.length > 0 ? approved : enrollment.activities

  const byActivity = generateQRCodesForEnrollment({
    id: enrollment.id,
    activities,
    activityQuantities: enrollment.activityQuantities
  })

  return byActivity[0]?.qrCodes[0] ?? null
}
